/*
 * WelcomePage.module.css
 *
 * Intentionally uses hardcoded colors — NOT CSS theme variables — so the
 * welcome screen always renders in the same light style regardless of the
 * user's dark/light theme preference.
 */

.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 40px 20px;

  background-image: url('/wallpaper.jpg');
  background-repeat: repeat;
  background-size: 256px 256px;
}

.title {
  font-family: var(--font-family-base);
  font-size: clamp(2.5rem, 6vw, 5rem);
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: 0.02em;
  text-shadow: 0 1px 3px rgba(255, 255, 255, 0.6);
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  text-align: center;
  unicode-bidi: plaintext;
}

.logo {
  width: 20vw;
  min-width: 120px;
  max-width: 320px;
  height: auto;
  border-radius: 8px;
}

.actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.loginBtn,
.registerBtn {
  padding: 12px 32px;
  border-radius: 6px;
  font-family: var(--font-family-base);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  border: 2px solid #1a1a1a;
}

.loginBtn:hover,
.registerBtn:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}

.loginBtn {
  background: #1a1a1a;
  color: #ffffff;
}

.registerBtn {
  background: transparent;
  color: #1a1a1a;
}
